import React, { forwardRef } from 'react';
import AsyncSelect from 'react-select/async';
import { Props as SelectProps, components } from 'react-select';
import { getSelectStyles, SelectFieldWrapper, CustomOption } from './SelectInput';

// Custom Input that adds data attributes to prevent password managers
function NoAutofillInput(props: any) {
	return (
		<components.Input {...props} data-1p-ignore data-lpignore="true" data-form-type="other" autoComplete="off" />
	);
}

interface AsyncSelectProps extends SelectProps {
	label: React.ReactNode;
	required?: boolean;
	error?: string;
	className?: string;
	loadOptions: (inputValue: string) => Promise<any[]>;
	renderOption?: (option: any) => React.ReactNode;
	defaultOptions?: boolean | any[];
	cacheOptions?: boolean | any;
	isClearable?: boolean;
	/** Rendered on the field's outer wrapper div — see the note on `SelectInput`. */
	'data-test-id'?: string;
}

export const AsyncSelectInput = forwardRef<any, AsyncSelectProps>(
	({ label, required, error, className, loadOptions, renderOption, 'data-test-id': dataTestId, ...props }, ref) => {
		const selectStyles = getSelectStyles(props.styles, error, props.isDisabled);

		const componentsOverride = {
			Option: (optionProps: any) => <CustomOption {...optionProps} renderOption={renderOption} />,
			IndicatorSeparator: () => null,
			Input: NoAutofillInput,
		};

		return (
			<SelectFieldWrapper
				label={label}
				required={required}
				error={error}
				className={className}
				isDisabled={props.isDisabled}
				data-test-id={dataTestId}
			>
				<AsyncSelect
					{...props}
					ref={ref}
					loadOptions={loadOptions}
					className="react-select"
					classNamePrefix="react-select"
					styles={{
						...selectStyles,
						menuPortal: base => ({ ...base, zIndex: 9999 }),
					}}
					menuPortalTarget={typeof document !== 'undefined' ? document.body : undefined}
					components={{
						...componentsOverride,
						...props.components,
					}}
				/>
			</SelectFieldWrapper>
		);
	},
);
